import { MenuItem } from "@mui/material";
import {
  isVariationOfAll,
  ALL_GROUP_NAME_DISPLAY,
  createAllProcessGroup,
} from "./filtersDrawerUtils";
import { updateTrendsPageFilterState } from "../../../providers/GlobalStateProvider";
import type { TrendsPageFilterStateType } from "../../../types/types";
import { useDispatch } from "react-redux";
import {
  useTrendsPageFilterState,
  useVisibleGroups,
} from "utils/customHooks/genericHooks";
import { useCustomerKey } from "utils/customHooks/useCustomerKey";
import { useMemo } from "react";

const FilterByGroupDropdownItems = ({ handleClose }) => {
  const ckey = useCustomerKey();
  const dispatch = useDispatch();
  const { trendsPageFilterState } = useTrendsPageFilterState();
  const visibleGroups = useVisibleGroups();
  const groupNameList = useMemo(
    () => visibleGroups.map(group => group.longName),
    [visibleGroups]
  );
  const isReady = groupNameList.length >= 1;

  const defaultGroupFilter = groupNameList.find(groupName =>
    isVariationOfAll(groupName)
  );

  // the preferredGroup comes from the store with initial value "All," but some clients have custom default names for the group that contains all processes
  const selectedGroup =
    defaultGroupFilter && isVariationOfAll(trendsPageFilterState.group)
      ? defaultGroupFilter
      : trendsPageFilterState.group;

  const shouldAddAllGroup =
    !defaultGroupFilter && !groupNameList.includes(ALL_GROUP_NAME_DISPLAY);

  // we can only filter by group OR process, not both, so...
  const handleGroupDropdownChange = groupName => {
    const newGroupFilter: string = groupName;
    // ...if the group was changed from the previous value...
    if (trendsPageFilterState.group !== newGroupFilter) {
      // ...we must switch the process back to the "all" process
      const allProcessGroup = createAllProcessGroup(ckey);
      const allProcess = allProcessGroup.processes[0];
      const newFilterState: TrendsPageFilterStateType = {
        ...trendsPageFilterState,
        group: newGroupFilter,
        process: allProcess,
      };
      dispatch(updateTrendsPageFilterState({ newFilterState }));
    }
  };

  return isReady ? (
    <>
      {[
        ...(shouldAddAllGroup ? [ALL_GROUP_NAME_DISPLAY] : []),
        ...groupNameList,
      ].map(groupName => {
        return (
          <MenuItem
            className={groupName === selectedGroup ? "active" : ""}
            key={groupName}
            value={groupName}
            data-value={groupName}
            disabled={groupName === selectedGroup}
            onClick={event => {
              event.stopPropagation();
              if (groupName === selectedGroup) {
                return;
              }
              handleGroupDropdownChange(groupName);
              handleClose();
            }}
          >
            {groupName}
          </MenuItem>
        );
      })}
    </>
  ) : null;
};

export default FilterByGroupDropdownItems;
